; (function () {

    addEventListener("DOMContentLoaded", (event) => {
        let nowDateTime = new Date();
        const changeDateTime = new Date('2026-08-03T00:00');

        const searchParams = new URLSearchParams(window.location.search);
        const testDateParam = searchParams.get('testdate'); // 日時文字列形式 YYYY-MM-DDTHH:mm:ss

        if (testDateParam) {
            nowDateTime = new Date(testDateParam);
        }

        if (changeDateTime <= nowDateTime) {
            //切り替え後
            const textAfter = document.querySelectorAll('.js-change-shopping-credit-plan.after');
            textAfter.forEach(function(element){
                element.classList.remove("hidden");
            });

            // 商品詳細ページ
            if(window.theme.pageType === 'product'){
                changeShoppingCreditPlanProduct();

            // Aboutページ
            }else if(location.pathname === '/pages/about'){
                changeShoppingCreditPlanAbout();
            }
            
        } else {
            //切り替え前
            const textBefore = document.querySelectorAll('.js-change-shopping-credit-plan.before');
            textBefore.forEach(function(element){
                element.classList.remove("hidden");
            });
        }
    
    });
    
    //商品詳細ページの処理
    const changeShoppingCreditPlanProduct = () => {
        const storeNum = document.querySelector('.js-change-shopping-credit-plan_STORENUM');
        const rateCode = document.querySelector('.js-change-shopping-credit-plan_RATECODE');
        // if(storeNum){
        //     storeNum.value = "10111935";
        // }
        if(rateCode){
            rateCode.value = "A3PH3";
        }
    }

    //Aboutページの処理
    const changeShoppingCreditPlanAbout = () => {
        const JaccsLoanText = document.querySelector('.js-change-shopping-credit-plan_JaccsLoanText');
        const JaccsLoanTextBefore = '36回払いまで分割金利手数料が無料！最大60回まで分割が可能です。';
        const JaccsLoanTextAfter = '最大36回払いの分割金利手数料が無料！60回まで分割支払いが可能です。';
        if(JaccsLoanText.textContent){
            const replacedText = JaccsLoanText.textContent ? JaccsLoanText.textContent.replace(JaccsLoanTextBefore, JaccsLoanTextAfter) : JaccsLoanText.textContent;
            JaccsLoanText.textContent = replacedText;
        }
    }

    // //ミエルカで挿入されている場合の上書き
    // window.onload = function() {
    //     if(location.pathname === '/cart' || location.pathname === '/account/login'){
    //         const IconTextBlock = document.querySelectorAll('.Icon-Text_Block .Icon-Text');
    //         IconTextBlock.forEach(function(element, index){
    //             if(index === 0){
    //                 element.innerHTML = element.innerHTML.replace('充実の保証期間', 'プロが鑑定！安心の商品保証')
    //             }
    //             if(index === 2 && location.pathname === '/cart'){
    //                 element.innerHTML = element.innerHTML.replace('36回まで金利無料、最大60回分割可能', '最大36回金利無料、60回まで分割可能')
    //             }
    //         });
    //     }
    // }

}());